// extracted by mini-css-extract-plugin
export default {"footerCheckboxContainer":"FooterCheckbox_footerCheckboxContainer__EF5mt","footerCheckbox":"FooterCheckbox_footerCheckbox__zddcT","checkboxText":"FooterCheckbox_checkboxText__E+R1d"};